import React from "react";

import AbstractFooter from "./AbstractFooter";

export default () => (
    <AbstractFooter>
        <div>
            <span>Powered by</span>
            &nbsp;
            <span css={{ fontWeight: 500 }}>glee</span>
        </div>
    </AbstractFooter>
);
